<template>
    <div class="page-content why-insurance mb-60">
        <div class="own-title margin-bottom-20">
            Life Insurance Opportunity
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/01.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/01.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/02.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/02.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/03.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/03.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/04.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/04.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/05.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/05.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/06.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/06.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/07.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/07.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/08.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/08.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/iPad/09.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/09.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium" :style="loadBg">
            <div>
                <div class="ipad-display text-center">
                    <img :src="'images/mpower-new/lio/card/10.png'" class="img-resize ipad">
                </div>
                <div class="mobile-display">
                    <img v-bind:src="'images/mpower-new/lio/card/10.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                </div>
            </div>
        </div>

        <div class="content card round-medium">
            <div class="center-text lio-01 ipad-display">
                According to a survey on global successful
                insurance professionals, benefits derive from 
                life insurance
            </div>

            <div class="center-text lio-02 mobile-display">
                According to a survey on global successful
                insurance professionals, benefits derive from 
                life insurance
            </div>
        </div>

        <div class="content card round-medium" >
            <div class="ipad-display text-center">
                <img :src="'images/mpower-new/lio/benefit/iPad/01.png'" class="img-resize ipad">
            </div>
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/lio/benefit/01.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium" >
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/lio/benefit/02.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium mobile-display">
            <div class="">
                <img v-bind:src="'images/mpower-new/lio/benefit/03.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium mobile-display">
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/lio/benefit/04.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium mobile-display">
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/lio/benefit/05.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium">
            <div class="ipad-display text-center">
                <img :src="'images/mpower-new/lio/quote/iPad/01.png'" class="img-resize ipad">
            </div>
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/lio/quote/01.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium mobile-display">
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/lio/quote/02.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium mobile-display">
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/lio/quote/03.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
            </div>
        </div>

        <div class="content card round-medium">
            <div class="center-text lio-03 ipad-display">
                Here’s why you should consider<br> a path in Life Insurance!  
            </div>

            <div class="center-text lio-04 mobile-display">
                Here’s why you should consider a path in Life Insurance!  
            </div>
        </div>
        <div class="divider divider-margins divider-no-bg"></div>
    </div>
</template>
<style scoped> 

.lio-01 {
    font-family: "HelveticaNeueLTStd-Bd";
    color: #ffffff !important;
    font-size: 18px;
    /* line-height: 20.8px; */
}

.lio-02 {
    color: #ffffff !important;
    font-size: 14px;
    /* line-height: 16px; */
}

.lio-03 {
    font-family: "HelveticaNeueLTStd-Bd";
    color: #ffffff !important;
    font-size: 20px;
    /* line-height: 24px; */
}

.lio-04 {
    color: #ffffff !important;
    font-size: 15px;
}

.divider-no-bg {
    background-color: unset !important;
}
.mb-10 {
    margin-bottom: 10px !important;
}
.mb-30 {
    margin-bottom: 30px !important;
}
.mb-60 {
    margin-bottom: 60px !important;
}
.mobile-2-col-text-wrapper {
    padding: 20px; 
}
.ipad-2-col-grid-wrapper {
    padding: 20px 50px;
}
.ipad-2-col-text-wrapper {
    padding: 50px;
}
.subheading-title {
    font-size: 14px;
    color: #fff;
    font-weight: bold;
}
.source-title {
    margin-top: 10px !important;
    font-size : 9px;
    color : rgb(255,255,255,0.4);
}
.normal-highlight {
    font-size: 20px;
    color: rgb(255,255,255,0.7);
    line-height: normal;
}
.red-highlight {
    font-size: 20px;
    font-weight: bold;
    color: #E44F59;
}
.grid-bg {
    background : #2B2B2B;
}
.grid-title {
    font-weight : bold;
    font-size : 15px;
    color : #54D2E3;
    margin: 5px 0 5px 0;
}
.grid-description {
    font-size: 9px;
    color: rgb(255,255,255,0.7);
}
.grid-half {
    width: 49.5%;
    margin-right: 1%;
    float: left;
    height: 150px;
}
.grid-half.last-column {
    width: 49.5%;
    margin: 0% 0% 1% 0%;
    float: left;
}
.umbrella-wrapper {
    position: absolute;
}
.umbrella-text-wrapper {
    position: relative;
}
.umbrella-tablet-img{
    max-width: 100%; 
    margin: 0 12%;
}
.umbrella-mobile-img {
    max-height: 197px;
    margin: 0 auto;
}
.question-mobile-img {
    max-width: 100%;
    max-height: 197px;
    margin: 0 auto;
}
.question-img {
    max-width: 100%;
    margin: 0 auto;
}
.text-left {
    text-align: left;
}
.grid-image {
    margin: 0 auto;
    max-width: 50px;
}
.img-resize {
    max-width: 50%;
    max-height: 100%;
    margin: 0 auto;
}
.border-rad-15 {
    border-radius: 15px;
}
.p-insurance-font {
    font-size : 11px;
    color: rgb(255,255,255,0.8) !important;
}
.desc{
  padding:10%;
}
.caption-image img{
  width: 80%;
}
.second-row{
  margin-top: -10%;
  display: inline-flex;
}
.opportunity{
    color:#fbda8a;
    margin-bottom: 20px;
    /* font-size: 15px; */
}
@media(min-width: 450px){
  .icon-column-center{
      min-width: 220px;
  }
}
@media (max-width: 575px){
    .img-resize{
        max-width: 100% !important;
    }
    .float-left{
      float: left;
    }
    .float-right{
      float: right;
    }
}
@media (min-width: 768px){
    .source-title,.grid-description{
        font-size: 11px;
    }
    .p-insurance-font{
        font-size: 13px;
    }
    .grid-title,.subheading-title{
        font-size: 18px;
    }
}
@media (max-width: 765px){
    .normal-highlight {
        font-size: 11px !important;
    }
    .red-highlight {
        font-size: 13px !important;
    }
}
@media (max-width: 400px){
  .second-row{
    margin-top: -10%;
    display: inline-flex;
  }
  .desc{
    padding:5% 10%;
  }
}
</style>
<script>
export default {
    name: 'Life_insurance_opportunity',
    computed: {
        loadBg(){
            return {
                'backgroundImage': 'url(\'images/mpower-new/lio/background/blank.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        },
    }, 
    mounted(){
        document.querySelector(".header-s").style.display = "block";
        document.querySelector(".header").style.zIndex = "96";
    },
}
</script>